import { findByCode, findByName, extractData } from "../helpers";
import artifacts from "./artifacts";
import characters from "./characters";
import weapons from "./weapons";

export const findCharacter = (char, projection) => {
  const data = findByName(characters, char.name);
  return projection ? extractData(data, projection) : data;
};

export const findWeapon = ({ type, code }, projection) => {
  const data = findByCode(weapons[type], code);
  return projection ? extractData(data, projection) : data;
};

export function findArtifact({ code, type }) {
  const tgSet = findByCode(artifacts, code);
  if (type) {
    const { name, icon } = tgSet[type];
    return { beta: tgSet.beta, name, icon };
  }
  return tgSet;
}
export function findArtBuff(art, index) {
  const { buffs } = findArtifact(art);
  return buffs?.[index];
}

export function getCharacterData(char, select) {
  const defaultSelect = "nation vision";
  select = (select || defaultSelect) + " actvTalents";
  const { actvTalents, ...info } = findCharacter(char, select);
  let EBcost = 0;
  for (const tl of actvTalents) {
    if (tl.energyCost) {
      EBcost = tl.energyCost;
      break;
    }
  }
  return { ...info, EBcost };
}

export function getPartyData(party) {
  return party
    .filter((tm) => tm)
    .map((tm) => getCharacterData(tm, "name nation vision"));
}

/*
function findManyCharacters({
  filter,
  alternate,
  select = "name code beta icon rarity vision weapon"
}) {
  function pickSelectedFields(data) {
    const info = {};
    for (const field of select.split(" ")) {
      info[field] = data[field];
    }
    return info;
  }
  if (filter) {
    if (alternate) {
      const result = [];
      for (const char of characters) {
        if (filter(char)) {
          result.push(pickSelectedFields(char));
        } else {
          result.push(alternate(char));
        }
      }
      return result;
    }
    else {
      const result = [];
      for (const char of characters) {
        if (filter(char)) {
          result.push(pickSelectedFields(char));
        }
      }
      return result;
    }
  } else {
    return characters.map(pickSelectedFields);
  }
}
*/
